import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import {unchooseCategory} from 'catalog/actions/categories';

@connect(
    state => ({
        category: state.categories.activeCategory,
        subCategory: state.categories.activeSubcategory,
    }),
    dispatch => ({
        deselect1: (e) => {
            e.preventDefault();
            dispatch(unchooseCategory(false))
        },
        deselect2: (e) => {
            e.preventDefault();
            dispatch(unchooseCategory(true))
        }
    })
)
export default class CategoryBreadcrumbs extends Component {


    render() {
        const {category, subCategory} = this.props;
        const breadcrumbs = [];
        if (category) {
            breadcrumbs.push(
                <BreadcrumbItem key='category_breadcrumb'>
                    <a href="#" onClick={this.props.deselect1} color='default'>
                        {category.name}
                    </a>
                </BreadcrumbItem>,
            )
        }
        if (subCategory) {
            breadcrumbs.push(
                <BreadcrumbItem key='sub_category_breadcrumb'>
                    <a href="#" onClick={this.props.deselect2} className='text-danger'>
                        {subCategory.name}
                    </a>
                </BreadcrumbItem>,
            )
        }
        if (breadcrumbs.length) {
            return (
                <Breadcrumb>
                    {breadcrumbs}
                </Breadcrumb>
            )
        }
        return null;
    }
}
